<div class="fullModal opened tunnelers-form-container">
  <div class="title" style="filter: brightness(50%)">Install a Tunneler</div>
  <div class="subtitle">Choose the software for your OS</div>
  <div class="tunneler-cards-container">
    @for (item of tunnelerItems; track item) {
      <app-tunneler-card
        (selected)="itemSelected()"
        [item]="item"
      ></app-tunneler-card>
    }
  </div>
  <div (click)="hide()" class="buttonBall close" id="EscTunnelerCards">
    <div class="buttonLabel">ESC</div>
  </div>
</div>
